// src/components/common/Icons.jsx
// NOBISHIROカスタムSVGアイコン - 絵文字置き換え用ピクトグラム
import React from 'react';

const Ico = ({ size = 20, color = 'currentColor', children, style }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
    style={{ flexShrink: 0, ...style }}>
    {children}
  </svg>
);

// 🌱 成長・スタート
export const IconSeedling = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <path d="M12 22V12"/>
    <path d="M12 12C12 7 7 4 3 5c0 5 3 8 9 7"/>
    <path d="M12 12c0-5 5-8 9-7c0 5-3 8-9 7"/>
  </Ico>
);

// 📚 学習・インプット
export const IconBook = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
    <line x1="9" y1="7" x2="15" y2="7"/>
    <line x1="9" y1="11" x2="12" y2="11"/>
  </Ico>
);

// ⚡ エネルギー・突破
export const IconBolt = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
  </Ico>
);

// 🔥 ストリーク・炎
export const IconFlame = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/>
  </Ico>
);

// 🚀 スタート・成長加速
export const IconRocket = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z"/>
    <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"/>
    <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0"/>
    <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5"/>
  </Ico>
);

// 🏆 トロフィー・完走
export const IconTrophy = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <line x1="8" y1="21" x2="16" y2="21"/>
    <line x1="12" y1="17" x2="12" y2="21"/>
    <path d="M7 4h10v8a5 5 0 0 1-10 0V4z"/>
    <path d="M7 4H4a2 2 0 0 0 0 4h3"/>
    <path d="M17 4h3a2 2 0 0 1 0 4h-3"/>
  </Ico>
);

// 🎤 マイク・音声
export const IconMic = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
    <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
    <line x1="12" y1="19" x2="12" y2="23"/>
    <line x1="8" y1="23" x2="16" y2="23"/>
  </Ico>
);

// 📊 グラフ・分析
export const IconChart = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <line x1="18" y1="20" x2="18" y2="10"/>
    <line x1="12" y1="20" x2="12" y2="4"/>
    <line x1="6" y1="20" x2="6" y2="14"/>
    <line x1="2" y1="20" x2="22" y2="20"/>
  </Ico>
);

// 🧠 思考・認知
export const IconBrain = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96-.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 4.44-1.66z"/>
    <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96-.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-4.44-1.66z"/>
  </Ico>
);

// 🎯 ターゲット・目標
export const IconTarget = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <circle cx="12" cy="12" r="10"/>
    <circle cx="12" cy="12" r="6"/>
    <circle cx="12" cy="12" r="2"/>
  </Ico>
);

// 🤝 チーム・連携
export const IconHandshake = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 0C1.46 6.7 1.33 10.28 4 13l8 8 8-8c2.67-2.72 2.54-6.3.42-8.42z"/>
    <path d="M12 5.36 8.87 8.5a2.13 2.13 0 0 0 0 3l3.13 3.13 3.13-3.13a2.13 2.13 0 0 0 0-3L12 5.36z"/>
  </Ico>
);

// 💡 ヒント・アイデア
export const IconLightbulb = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <line x1="9" y1="18" x2="15" y2="18"/>
    <line x1="10" y1="22" x2="14" y2="22"/>
    <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"/>
  </Ico>
);

// 📈 成長・上昇
export const IconTrendUp = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
    <polyline points="17 6 23 6 23 12"/>
  </Ico>
);

// 👥 チーム・グループ
export const IconUsers = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </Ico>
);

// 🔑 キー・アーキタイプ
export const IconKey = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <circle cx="7.5" cy="15.5" r="5.5"/>
    <path d="m21 2-9.6 9.6"/>
    <path d="m15.5 7.5 3 3L22 7l-3-3"/>
  </Ico>
);

// 🔄 振り返り・リフレッシュ
export const IconRefresh = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <polyline points="23 4 23 10 17 10"/>
    <polyline points="1 20 1 14 7 14"/>
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
  </Ico>
);

// ⏰ 時間・スケジュール
export const IconClock = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </Ico>
);

// 🗓 カレンダー
export const IconCalendar = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
    <line x1="16" y1="2" x2="16" y2="6"/>
    <line x1="8" y1="2" x2="8" y2="6"/>
    <line x1="3" y1="10" x2="21" y2="10"/>
  </Ico>
);

// ✅ チェック・完了
export const IconCheck = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <polyline points="20 6 9 17 4 12"/>
  </Ico>
);

// 🏅 メダル・実績
export const IconMedal = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <circle cx="12" cy="8" r="6"/>
    <path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/>
  </Ico>
);

// 📝 ログ・メモ
export const IconEdit = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <path d="M12 20h9"/>
    <path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/>
  </Ico>
);

// 🧗 クライマー
export const IconClimber = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <circle cx="12" cy="4" r="2"/>
    <path d="m14 12 2 4-4-1-2 5"/>
    <path d="m8 12-2 4"/>
    <path d="M12 6v6l3 3"/>
    <path d="M9 9H6"/>
  </Ico>
);

// 🔬 リサーチ・調査
export const IconSearch = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <circle cx="11" cy="11" r="8"/>
    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
  </Ico>
);

// 💬 議論・コミュニケーション
export const IconChat = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
  </Ico>
);

// 🎨 制作・クリエイティブ
export const IconPalette = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <circle cx="13.5" cy="6.5" r=".5" fill={color}/>
    <circle cx="17.5" cy="10.5" r=".5" fill={color}/>
    <circle cx="8.5" cy="7.5" r=".5" fill={color}/>
    <circle cx="6.5" cy="12.5" r=".5" fill={color}/>
    <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/>
  </Ico>
);

// LIVE バッジ用
export const IconActivity = ({ size, color, style }) => (
  <Ico size={size} color={color} style={style}>
    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
  </Ico>
);
